"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroShowcase() {
  const scrollToNextSection = () => {
    if (typeof window !== "undefined") {
      const nextSection = document.querySelector("section:nth-of-type(2)");
      if (nextSection) {
        nextSection.scrollIntoView({
          behavior: "smooth"
        });
      } else {
        window.scrollTo({
          top: window.innerHeight,
          behavior: "smooth"
        });
      }
    }
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 opacity-15 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/ethereal_texture_overlay.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/ethereal_texture_overlay.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/ethereal_texture_overlay.png-wvc-sizes" alt="Background Texture" className="w-full h-full object-cover" loading="lazy" decoding="async" />
      </div>

      <div className="container relative z-10 px-6 py-20 flex flex-col items-center">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0 items-center w-full max-w-7xl">
          
          {}
          <div className="lg:col-span-5 flex flex-col items-start text-left space-y-10 order-2 lg:order-1 lg:pr-12">
            <div className="space-y-4">
              <span className="text-[10px] uppercase tracking-[0.3em] font-sans text-foreground/50 block animate-in fade-in slide-in-from-bottom-4 duration-700">
                The Celebration of Love
              </span>
              <h1 className="text-6xl md:text-8xl font-serif font-light tracking-tighter text-primary leading-[0.85] lg:-ml-1 animate-in fade-in slide-in-from-bottom-6 duration-1000 delay-100">
                Jane <br />
                <span className="italic pl-8 md:pl-16 text-primary/80">& Liam</span>
              </h1>
            </div>

            <p className="text-lg md:text-xl font-serif italic text-foreground/70 max-w-md leading-relaxed animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-200">
              Join us as we begin our greatest adventure together in the heart of the countryside.
            </p>

            <div className="flex flex-wrap gap-6 pt-4 animate-in fade-in slide-in-from-bottom-10 duration-1000 delay-300">
              <Button asChild variant="default" className="rounded-lg px-10 py-7 text-xs uppercase tracking-[0.2em] font-sans shadow-sm hover:shadow-md transition-all duration-500 bg-primary text-primary-foreground">
                <Link to="/RSVPPage">RSVP</Link>
              </Button>
              <Button asChild variant="outline" className="rounded-lg px-10 py-7 text-xs uppercase tracking-[0.2em] font-sans border-primary/20 hover:bg-primary/5 transition-all duration-500">
                <Link to="/WeddingDetailsPage">The Details</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 relative order-1 lg:order-2 mb-12 lg:mb-0">
            <div className="relative w-full aspect-[4/5] md:aspect-[3/4] max-w-lg ml-auto">
              {}
              <div className="absolute inset-0 overflow-hidden rounded-lg shadow-xl z-10 animate-in fade-in zoom-in-95 duration-1000">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/hero_main_portrait.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/hero_main_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/hero_main_portrait.png-wvc-sizes" alt="Jane and Liam Portrait" className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000 ease-out" loading="lazy" />
              </div>
              
              {}
              <div className="absolute -bottom-10 -left-10 w-40 h-56 hidden md:block overflow-hidden rounded-lg shadow-lg z-20 border-[12px] border-background animate-in fade-in slide-in-from-left-10 duration-1000 delay-500">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/hero_detail_shot.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/hero_detail_shot.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/hero_detail_shot.png-wvc-sizes" alt="Wedding Detail" className="w-full h-full object-cover" loading="lazy" />
              </div>

              {}
              <div className="absolute -top-4 -right-4 bg-background/95 backdrop-blur-sm p-8 rounded-lg shadow-sm z-20 hidden md:flex flex-col items-center justify-center min-w-[160px] border border-primary/5 animate-in fade-in slide-in-from-top-10 duration-1000 delay-700">
                <span className="text-[10px] uppercase tracking-widest font-sans text-foreground/40 mb-2">Save the Date</span>
                <div className="h-px w-8 bg-primary/20 mb-3" />
                <span className="text-2xl font-serif text-primary">08.24.25</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4">
        <span className="text-[9px] uppercase tracking-[0.4em] font-sans text-foreground/40 rotate-90 origin-left translate-x-1 mb-8">
          Scroll
        </span>
        <Button variant="ghost" size="icon" onClick={scrollToNextSection} className="rounded-lg text-primary/30 hover:text-primary hover:bg-transparent animate-bounce" aria-label="Scroll to next section">
          <ArrowDown className="size-5 stroke-[1px]" />
        </Button>
      </div>
    </section>;
}